import React, { createContext, useState } from 'react'
import { DownloadOverlayInit } from '../constants/DownloadOverlayInit'

const LayoutContext = createContext({
  navOpacity: false,
  setNavOpacity: () => {},
  menuIsOpen: false,
  setMenuIsOpen: () => {},
  visibleDownloadOverlay: {
    visibility: false,
    offsetX: null,
    offsetY: null,
    url: null,
  },
  setVisibleDownloadOverlay: () => {},
  pauseVideo: false,
  setPauseVideo: () => {},
})

export const LayoutProvider = ({ children }) => {
  const setNavOpacity = (value) => {
    setState((prevState) => ({
      ...prevState,
      navOpacity: value,
    }))
  }

  const setMenuIsOpen = (value) => {
    setState((prevState) => ({
      ...prevState,
      menuIsOpen: value,
    }))
  }

  const setVisibleDownloadOverlay = (value) => {
    setState((prevState) => ({
      ...prevState,
      visibleDownloadOverlay: value,
    }))
  }

  const setPauseVideo = (value) => {
    setState((prevState) => ({
      ...prevState,
      pauseVideo: value,
    }))
  }

  const initState = {
    navOpacity: false,
    setNavOpacity: setNavOpacity,
    menuIsOpen: false,
    setMenuIsOpen: setMenuIsOpen,
    visibleDownloadOverlay: DownloadOverlayInit,
    setVisibleDownloadOverlay: setVisibleDownloadOverlay,
    pauseVideo: false,
    setPauseVideo: setPauseVideo,
  }

  const [state, setState] = useState(initState)

  return (
    <LayoutContext.Provider value={state}>{children}</LayoutContext.Provider>
  )
}

export default LayoutContext
